(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["swatch-grid-1"] && !Shopify.designMode) return;
  try {
    window.updateCardImage = function (swatch) {
    var newSrc = swatch.getAttribute('data-hover-image');
    if (!newSrc) return;

    var card = swatch.closest('.product-card');
    if (!card) return;

    var img = card.querySelector('.first-image') || card.querySelector('.product-card__image img');

    if (img) {
      img.src = newSrc;
      img.srcset = newSrc;
      img.setAttribute('data-src', newSrc);
      img.setAttribute('data-srcset', newSrc);
      img.classList.remove('lazyload');
      img.classList.add('lazyloaded');

      img.style.opacity = '1';
      img.style.visibility = 'visible';
      img.style.zIndex = '2';

      var imgWrapper = card.querySelector('.product-card__image');
      if (imgWrapper) {
        var otherImages = imgWrapper.querySelectorAll('img:not(.first-image)');
        otherImages.forEach(function (other) {
          other.style.display = 'none'; // Desaparecer a la competencia
          other.style.opacity = '0';
        });
      }
    }
  };

  window.selectCyberOption = function (element, type) {
    var container = element.closest('.cyber-swatches-container');
    var card = element.closest('.product-card');
    if (!container || !card) return;

    var siblings = element.parentElement.querySelectorAll('li');
    siblings.forEach(function (s) { s.classList.remove('is-active'); });
    element.classList.add('is-active');

    if (type === 'color') {
      window.updateCardImage(element);
    }

    var colorActive = container.querySelector('.cyber-swatch-item.is-active');
    var sizeActive = container.querySelector('.cyber-size-item.is-active');

    var colorIndex = container.getAttribute('data-color-index');
    var sizeIndex = container.getAttribute('data-size-index');

    var colorVal = colorActive ? colorActive.getAttribute('data-value') : null;
    var sizeVal = sizeActive ? sizeActive.getAttribute('data-value') : null;

    var variantsJsonEl = card.querySelector('.cyber-variants-json');
    if (!variantsJsonEl) return;

    var variants = [];
    try {
      variants = JSON.parse(variantsJsonEl.textContent);
    } catch (e) {}

    if (variants.length > 0) {
      var foundVariant = null;
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var match = true;
        if (colorIndex && colorVal && String(v[colorIndex]) !== colorVal) match = false;
        if (sizeIndex && sizeVal && String(v[sizeIndex]) !== sizeVal) match = false;
        if (match) { foundVariant = v; break; }
      }

      var btns = card.querySelectorAll('.js-grid-cart');

      if (foundVariant) {
        btns.forEach(function (btn) {
          btn.setAttribute('data-id', foundVariant.id);
          if (window.jQuery) window.jQuery(btn).data('id', foundVariant.id);

          var span = btn.querySelector('span:last-of-type');
          if (foundVariant.available) {
            btn.classList.remove('disabled');
            if (span) span.textContent = 'Agregar al carrito';
          } else {
            btn.classList.add('disabled');
            if (span) span.textContent = 'Agotado';
          }
        });

        var priceContainer = card.querySelector('.product-card__price');
        if (priceContainer) {
          var formatMoney = function (cents) {
            if (typeof theme !== 'undefined' && theme.Currency && theme.Currency.formatMoney) {
              return theme.Currency.formatMoney(cents, theme.moneyFormat || '$' + '{' + '{amount}' + '}');
            }
            return '$' + (cents / 100).toFixed(2);
          };
          var priceHtml = '';
          if (foundVariant.compare_at_price > foundVariant.price) {
            priceHtml = formatMoney(foundVariant.price) + ' <s class="product-card__regular-price">' + formatMoney(foundVariant.compare_at_price) + '</s>';
            priceContainer.classList.add('product-card__pricesale');
          } else {
            priceHtml = formatMoney(foundVariant.price);
            priceContainer.classList.remove('product-card__pricesale');
          }
          priceContainer.innerHTML = priceHtml;
        }
      } else {
        btns.forEach(function (btn) {
          btn.classList.add('disabled');
          var span = btn.querySelector('span:last-of-type');
          if (span) span.textContent = 'No disponible';
        });
      }
    }
  };
  } catch(e) { console.error(e); }
})();

})();
